module.exports = __webpack_public_path__ + "img/rabier.394efcc8.png";